<button class="app-button" [disabled]="disabled" [type]="type">
    <ng-content></ng-content>
</button>
